import { useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';

const LoginPage = () => {
  const location = useLocation();
  const errorMsg = location.state?.error;

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-surface-page p-6"
      style={{
        backgroundImage:
          'url(https://images.unsplash.com/photo-1765046255479-669cf07a0230?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRhdGElMjB2aXN1YWxpemF0aW9uJTIwZ2VvbWV0cmljfGVufDB8fHx8MTc3NTIyNjk1Mnww&ixlib=rb-4.1.0&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="w-full max-w-md">
        <div className="glass-strong rounded-2xl p-8" data-testid="auth-container">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center gap-3 mb-2">
              <h1 className="text-3xl font-semibold tracking-tight text-brand">
                Ventas OS
              </h1>
              <img
                src="/bcm-logo.png"
                alt="BCM"
                className="h-9"
                data-testid="login-bcm-logo"
              />
            </div>
            <p className="text-text-secondary text-sm">
              AI-Native Agency Operating System
            </p>
          </div>

          {errorMsg && (
            <div
              className="mb-6 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm text-center"
              data-testid="login-error-message"
            >
              {errorMsg}
            </div>
          )}

          <Button
            onClick={handleGoogleLogin}
            className="w-full h-12 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 shadow-sm rounded-xl flex items-center justify-center gap-3 text-base font-medium transition-all"
            data-testid="google-login-button"
          >
            <svg width="20" height="20" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
            </svg>
            Sign in with Google
          </Button>

          <div className="mt-6 text-center">
            <p className="text-xs text-text-secondary">
              BCM Workspace accounts only
            </p>
            <p className="text-xs text-text-secondary mt-1">
              Contact your administrator if you need access
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
